/*
 *
 * Ideation actions
 *
 */

import * as Types from "./constants";

export function showSuccess(payload) {
	return {
		type: Types.TOAST_SUCCESS,
		payload: payload,
	};
}

export function showError(payload) {
	return {
		type: Types.TOAST_ERROR,
		payload: payload,
	};
}


export function getConvocationList() {
	return {
		type: Types.GET_CONVOCATION_LIST_REQUESTED,
	};
}

export function getRoleList() {
	return {
		type: Types.GET_ROLE_LIST_REQUESTED,
	};
}

export function getConvocationMentorList(id) {
	return {
		type: Types.GET_CONVOCATION_MENTOR_LIST_REQUESTED,
		payload: id,
	};
}

export function getActiveIdeaList(payload) {
	return {
		type: Types.GET_ACTIVE_IDEA_LIST_REQUESTED,
		payload,
	};
}

export function getInActiveIdeaList(payload) {
	return {
		type: Types.GET_INACTIVE_IDEA_LIST_REQUESTED,
		payload,
	};
}

export function resetIdeaList(payloa) {
	return {
		type: Types.RESET_IDEA_LIST,
	};
}
export function resetMyIdeasList(payloa) {
	return {
		type: Types.RESET_MY_IDEA_LIST,
	};
}

export function getILikedIdea(id) {
	return {
		type: Types.GET_CONVOCATION_MENTOR_LIST_REQUESTED,
		payload: id,
	};
}

export function getConvocationDetail(id) {
	return {
		type: Types.GET_CONVOCATION_DETAIL_REQUESTED,
		payload: id,
	};
}

export function getIdeaDetail(id) {
	return {
		type: Types.GET_IDEA_DETAIL_REQUESTED,
		payload: id,
	};
}

export function getMyClassMates() {
	return {
		type: Types.GET_MY_CLASS_MATES_LIST_REQUESTED,
		
	};
}

export function resetIdeasList() {
	return {
		type: Types.RESET_INACTIVE_IDEA_DETAIL,
		
	};
}

export function getMyReserveIdeaList() {
	return {
		type: Types.GET_MY_RESERVED_IDEA_LIST_REQUESTED,
	};
}
export function getMyIdeaList(param) {
	return {
		type: Types.GET_MY_IDEA_LIST_REQUESTED,
		payload:param
	};
}

export function addOrUpdateConvocation(payload) {
	return {
		type: Types.ADD_UPDATE_CONVOCATION_REQUESTED,
		payload,
	};
}

export function addOrUpdateAppendixConvocation(payload, onUploadProgress) {
	return {
		type: Types.ADD_UPDATE_APPENDIX_CONVOCATION_REQUESTED,
		payload,
		onUploadProgress,
	};
}

export function removeAppendixConvocation(payload) {
	return {
		type: Types.REMOVE_APPENDIX_CONVOCATION_REQUESTED,
		payload,
	};
}

export function addConvocationMentor(payload) {
	return {
		type: Types.ADD_CONVOCATION_MENTOR_REQUESTED,
		payload,
	};
}

export function removeConvocationMentor(payload) {
	return {
		type: Types.REMOVE_CONVOCATION_MENTOR_REQUESTED,
		payload,
	};
}

export function toggleIdeaStatus(payload) {
	return {
		type: Types.TOGGLE_IDEA_STATUS_REQUESTED,
		payload,
	};
}

export function toggleIdeaLike(payload) {
	return {
		type: Types.TOGGLE_IDEA_LIKE_REQUESTED,
		payload,
	};
}

export function addOrUpdateIdea(payload) {
	return {
		type: Types.ADD_UPDATE_IDEA_REQUESTED,
		payload,
	};
}

export function ideaMentoring(payload) {
	return {
		type: Types.IDEA_MENTORING_REQUESTED,
		payload,
	};
}

export function ideaLikeOrDislike(payload) {
	return {
		type: Types.IDEA_LIKE_DISLIKE_REQUESTED,
		payload,
	};
}

export function ideaComment(payload) {
	return {
		type: Types.IDEA_NEW_CHAT_REQUESTED,
		payload,
	};
}

export function seenNewChats(payload) {
	return {
		type: Types.IDEA_CHAT_SEEN_REQUESTED,
		payload,
	};
}

export function toggleIdeaFieldsStatus(payload) {
	return {
		type: Types.TOGGLE_IDEA_LIKE_REQUESTED,
		payload,
	};
}

export function acceptIdeaByMentor(payload) {
	return {
		type: Types.IDEA_ACCEPT_REQUESTED,
		payload,
	};
}

export function ideaLikeDislike(payload) {
	return {
		type: Types.IDEA_LIKE_DISLIKE_REQUESTED,
		payload,
	};
}


export function ideaSave(payload) {
	return {
		type: Types.IDEA_SAVE_REQUESTED,
		payload,
	};
}

export function ideaNewChat(payload) {
	return {
		type: Types.IDEA_NEW_CHAT_REQUESTED,
		payload,
	};
}

export function ideaChatSeen(id) {
	return {
		type: Types.IDEA_CHAT_SEEN_REQUESTED,
		payload: id,
	};
}

export function ideaRemove(id) {
	return {
		type: Types.IDEA_CHAT_SEEN_REQUESTED,
		payload: id,
	};
}

export function toggleIdeaReserve(payload) {
	return {
		type: Types.IDEA_RESERVE_OR_REMOVE_RESERVE_REQUESTED,
		payload,
	};
}
